module.exports = __webpack_public_path__ + "static/CircularStd-BlackItalic-0cda47fe41243fb61f2ffd71f3a811b8.otf";